import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// core components
import CheckBox from 'components/CheckBox/CheckBox';

// redux selector
import { getPaymentProfileList } from 'redux/selectors/PaymentProfileSelector';

// image
import plusIcon from 'assets/images/icons_svg/icon_plus.svg';

const PaymentProfileItem = ({
    card_type,
    id,
    safe_credit_card_number,
    onChange,
    checked,
    disabled
}) => {
    const ConvertCardText = (type) => {
        switch (type) {
            case 'visa':
                return 'Visa';
            case 'mc':
                return 'MasterCard';
            default:
                return 'UnknownCardType';
        }
    };
    return (
        <CheckBox
            onChange={!disabled ? onChange : undefined}
            checked={checked}
            label={
                <div>
                    <div>{ConvertCardText(card_type)}</div>
                    <div>{safe_credit_card_number}</div>
                </div>
            }
        />
    );
};
export const PaymentProfileList = ({
    paymentProfiles,
    book,
    bookTotalPrice,
    onAddNewPaymentProfile,
    onCreateBookOrder,
    isSubmittingPayment
}) => {
    const [activePaymentProfile, setActivePaymentProfile] =
        React.useState(null);
    const [isCheckoutLocked, setIsCheckoutLocked] = React.useState(false);
    const checkoutLockRef = React.useRef(false);

    const isProcessing = isSubmittingPayment || isCheckoutLocked;

    const onNext = React.useCallback(async () => {
        if (
            isProcessing ||
            checkoutLockRef.current ||
            !activePaymentProfile?.id
        ) {
            return;
        }

        try {
            checkoutLockRef.current = true;
            setIsCheckoutLocked(true);
            await onCreateBookOrder(activePaymentProfile);
        } finally {
            checkoutLockRef.current = false;
            setIsCheckoutLocked(false);
        }
    }, [activePaymentProfile, onCreateBookOrder, isProcessing]);

    const onChange = React.useCallback(
        (paymentProfile) => {
            if (isProcessing) {
                return;
            }
            setActivePaymentProfile(paymentProfile);
            // onCreateBookOrder && onCreateBookOrder(paymentProfile);
        },
        [isProcessing]
    );

    const canCheckout = Boolean(
        book?.shipping_address && book?.approved && activePaymentProfile?.id
    );

    return (
        <React.Fragment>
            {(paymentProfiles || [])
                .filter((profile) => !profile?.deleted)
                .map((paymentProfile) => (
                    <PaymentProfileItem
                        {...paymentProfile}
                        key={paymentProfile?.id}
                        checked={
                            activePaymentProfile?.id === paymentProfile?.id
                        }
                        disabled={isProcessing}
                        onChange={() => onChange(paymentProfile)}
                    />
                ))}

            <div className="add-new-item btn btn-outline btn--sm">
                <CheckBox
                    onChange={
                        !isProcessing ? onAddNewPaymentProfile : undefined
                    }
                    inActiveMark={plusIcon}
                    label="Add a new Credit Card"
                />
            </div>

            <div className="payment-checkout-btn">
                <button
                    disabled={isProcessing || !canCheckout}
                    className="btn btn-gradient btn--md"
                    onClick={onNext}
                >
                    Checkout
                </button>
            </div>
        </React.Fragment>
    );
};

const state = createStructuredSelector({
    paymentProfiles: getPaymentProfileList
});
export default connect(state)(PaymentProfileList);
